import angular from 'angular';
import { react2angular } from 'react2angular'
import Portal from './containers/Portal';
import Login from './containers/Login';
import Logout from './containers/Logout';
import Sidebar from './components/Sidebar';
import MenuBar from './components/MenuBar';
import UserButton from './components/UserButton';
import QuickSearchBox from './components/QuickSearchBox';
import Breadcrumb from './components/Breadcrumb';
import DetailsPane from './components/DetailsPane';
import Configuration from './containers/Configuration';
import DropOverlay from './components/DropOverlay';
import ReactRoot from './containers/ReactRoot';
import AdvancedSearchControls from './components/AdvancedSearchControls';
import { Icon } from 'dlweb-components';

angular.module('webTools').component('breadcrumb', react2angular(Breadcrumb, ['paths'], ['$location', '$rootScope']));
angular.module('webTools').component('detailsPane', react2angular(DetailsPane, ['store', 'dlObject'], ['$rootScope', 'File']));
angular.module('webTools').component('sidebar', react2angular(Sidebar, ['store'], ['$rootScope', '$location', '$routeParams']));
angular.module('webTools').component('portal', react2angular(Portal, ['store']));
angular.module('webTools').component('logout', react2angular(Logout, ['store'], ['$location', '$rootScope']));
angular.module('webTools').component('login', react2angular(Login, ['store'], ['$scope', '$location', '$rootScope', '$routeParams', '$ngRedux', 'Auth', 'Utility']));
angular.module('webTools').component('menuBar', react2angular(MenuBar, ['store', 'menuItems'], ['$rootScope']));
angular.module('webTools').component('userButton', react2angular(UserButton, ['store'], ['$rootScope', '$location']));
angular.module('webTools').component('quickSearchBox', react2angular(QuickSearchBox, ['store'], ['$rootScope', '$location']));
angular.module('webTools').component('configuration', react2angular(Configuration, ['store'], ['$rootScope', '$location', '$routeParams']));
angular.module('webTools').component('dropOverlay', react2angular(DropOverlay, ['store', 'visible', 'folderName'], ['$rootScope']));
angular.module('webTools').component('reactRoot', react2angular(ReactRoot, ['store'], ['$rootScope']));
angular.module('webTools').component('advancedSearchControls', react2angular(AdvancedSearchControls, ['onReset', 'onSave', 'onSearch'], ['$rootScope']));
angular.module('webTools').component('icon', react2angular(Icon, ['type', 'faStyle'], ['$rootScope']));

